import '../Order.less';

/**
 * Тооллогын төлвийн badge.
 * Жагсаалт болон дэлгэрэнгүй дээр адилхан харагдана.
 *
 * @param status - orderStatus-ийн эх утга (class-д хэрэглэгдэнэ)
 * @param label  - enumDictionary-с гарсан харагдах текст
 */
const InventoryStatusBadge = ({ status, label }) => {
  if (!status) return '-';

  return (
    <span className={`inventory-status-badge inventory-status-${status}`}>
      <span className="inventory-status-dot" />
      {label ?? status}
    </span>
  );
};

export default InventoryStatusBadge;
